import React, { useContext } from "react";
import { Box, Button, Heading, Layer, Text } from "grommet";
import { GlobalStateContext } from "../context/GlobalContextProvider";
import { GlobalDispatchContext } from "../context/GlobalContextProvider";
import { isBrowser } from "../hooks/auth";

export const CenterLayer = ({ children, props }) => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const { layer, centerLayerType } =
    state === null ? undefined : state;
  const { error, message } =
    state === null ? undefined : state.message;

  const buttonColor = () => {
    if (error) return "status-critical";
    else return "green";
  };

  function onClose() {
    dispatch({ type: "TOGGLE_LAYER" });
  }

  function onSubmit() {
    dispatch({ type: "START_ACTION" });
  }

  // function onOpen() {
  // }
  return (
    <>
      {layer ? (
        <Layer
          id="error-layer"
          position="center"
          onClickOutside={onClose}
          onEsc={onClose}
        >
          {/* Grommet forwards the `style` prop to an inner content box, not
              the outer overlay div that actually competes for stacking order
              against other open Layers (e.g. the admin edit-user modal) - so
              a `style={{ zIndex }}` prop on <Layer> itself has no effect on
              which modal renders on top. Target the outer div by its id
              instead, so this message always shows in front. */}
          <style>{"#error-layer { z-index: 2000000 !important; }"}</style>
          <Box pad="medium" gap="small" width="medium">
            {state.centerLayerType !== "action" ? (
              <Heading level={3} margin="none">
                {error ? "Oops!" : "Success!"}
              </Heading>
            ) : null}
            <Text>
              {/* {error
                ? "Invalid username or password. Please try again."
                : "Successful!"} */}
              {message
                ? message
                : error
                ? "An error occurred."
                : "Successful!"}
            </Text>
            <Box
              as="footer"
              gap="small"
              direction="row"
              align="center"
              justify="end"
              pad={{ top: "medium", bottom: "small" }}
            >
              {state.centerLayerType.includes("action") ? (
                <Box direction="row" gap="small">
                  <Button
                    label={
                      <Text color="white">
                        <strong>
                          {error === 400 ? "Back" : "Cancel"}
                        </strong>
                      </Text>
                    }
                    onClick={onClose}
                    primary
                    color="status-critical"
                  />
                  <Button
                    label={
                      <Text color="white">
                        <strong>
                          {error === 400 ? "Back" : "Ok"}
                        </strong>
                      </Text>
                    }
                    onClick={onSubmit}
                    primary
                    color="green"
                  />
                </Box>
              ) : (
                //<Button label="Open 2" onClick={onOpen2} color="dark-3" />
                <Button
                  label={
                    <Text color="white">
                      <strong>{error === 400 ? "Back" : "Ok"}</strong>
                    </Text>
                  }
                  onClick={onClose}
                  primary
                  color={buttonColor()}
                />
              )}
            </Box>
          </Box>
        </Layer>
      ) : null}

      {children}
    </>
  );
};
